import React from 'react';
import { FormProvider } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { getCountryCode } from '@/modules/common/store/selectors';
import { IPartner } from '@/modules/partner/model';
import { PaymentInfoForm } from '@/modules/partner/model/form';
import { getPartner } from '@/modules/partner/store/selectors';
import { ISubmitFormResult } from '@/shared/models/formSubmit';
import { BottomButtons } from '@/shared/view/BottomButtons';
import { useForm } from '@/shared/view/Form';
import { Button } from '@src-common/view/adapters/Button';

import { PaymentsView } from '../Wizard/components/Payments/view';

const mapPartnerToForm = ({
  paymentAccount,
  paymentRoutingNumber,
  paymentSortCode,
  paymentBik,
  paymentRasAccount,
  paymentSwift,
  paymentIban,
  paymentBankName,
  paymentKorAccount,
}: IPartner): PaymentInfoForm => ({
  accountNumber: paymentAccount,
  sortCode: paymentSortCode,
  routingNumber: paymentRoutingNumber,
  bik: paymentBik,
  rasAccount: paymentRasAccount,
  swift: paymentSwift,
  iban: paymentIban,
  bankName: paymentBankName,
  corAccount: paymentKorAccount,
});

type PaymentsFormProps = {
  usePreSaveStore?: boolean;
  textSubmitButton?: React.ReactNode;
  onSubmit: (formValues: PaymentInfoForm) => Promise<ISubmitFormResult<PaymentInfoForm>>;
};

const PaymentsForm: React.FC<PaymentsFormProps> = ({
  usePreSaveStore = true,
  textSubmitButton,
  onSubmit,
}) => {
  const partner = useSelector(getPartner);
  const countryCode = useSelector(getCountryCode);

  const { handleSubmit, form } = useForm({
    preSaveStore: usePreSaveStore
      ? {
          storeId: `paymentInfoStepForm-${partner.id}`,
          type: 'memory',
        }
      : undefined,
    onSubmit,
    defaultValues: mapPartnerToForm(partner),
  });

  const {
    control,
    formState: { isSubmitting },
  } = form;

  return (
    <FormProvider<PaymentInfoForm> {...form}>
      <form onSubmit={handleSubmit}>
        <PaymentsView
          control={control}
          partnerType={partner.partnerType}
          countryCode={countryCode}
        />
        <BottomButtons>
          <Button type="submit" isPending={isSubmitting}>
            {textSubmitButton || (
              <FormattedMessage
                defaultMessage="NEXT"
                id="6jg2Fp"
                description="OnBoarding next button text"
              />
            )}
          </Button>
        </BottomButtons>
      </form>
    </FormProvider>
  );
};

export { PaymentsForm };
